"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateEditableFieldsInCache = exports.computeChangeResult = exports.isPositiveInteger = exports.getNormalizedTaskCount = exports.getEditableFieldChange = void 0;
const get_hlqa_tasks_query_1 = require("../client/get-hlqa-tasks.query");
const constants_1 = require("./table-config/constants");
const getEditableFieldChange = (newRow, oldRow) => {
    const changedFields = [
        newRow.priority !== oldRow.priority ? constants_1.HLQATasksColumns.Priority : null,
        newRow.taskCount !== oldRow.taskCount ? constants_1.HLQATasksColumns.TaskCount : null,
        newRow.status !== oldRow.status ? constants_1.HLQATasksColumns.Status : null,
        newRow.assignedTo !== oldRow.assignedTo ? constants_1.HLQATasksColumns.AssignedTo : null,
    ].filter((field) => field !== null);
    if (changedFields.length !== 1) {
        return null;
    }
    return changedFields[0];
};
exports.getEditableFieldChange = getEditableFieldChange;
const getNormalizedTaskCount = (value) => {
    if (value === null || value === undefined) {
        return Number.NaN;
    }
    return value;
};
exports.getNormalizedTaskCount = getNormalizedTaskCount;
const isPositiveInteger = (value) => Number.isInteger(value) && value > 0;
exports.isPositiveInteger = isPositiveInteger;
const computeChangeResult = (changedField, row) => {
    var _a, _b, _c, _d;
    const nonTaskCountResultByField = {
        [constants_1.HLQATasksColumns.Priority]: {
            mutationPatch: { priority: row.priority },
            optimisticRow: row,
            shouldShowTaskCountError: false,
        },
        [constants_1.HLQATasksColumns.AssignedTo]: {
            mutationPatch: { assignedTo: (_a = row.assignedTo) !== null && _a !== void 0 ? _a : null },
            optimisticRow: Object.assign(Object.assign({}, row), { assignedTo: (_b = row.assignedTo) !== null && _b !== void 0 ? _b : null }),
            shouldShowTaskCountError: false,
        },
        [constants_1.HLQATasksColumns.Status]: {
            mutationPatch: { status: (_c = row.status) !== null && _c !== void 0 ? _c : null },
            optimisticRow: Object.assign(Object.assign({}, row), { status: (_d = row.status) !== null && _d !== void 0 ? _d : null }),
            shouldShowTaskCountError: false,
        },
    };
    if (changedField && changedField !== constants_1.HLQATasksColumns.TaskCount) {
        return nonTaskCountResultByField[changedField];
    }
    const normalizedTaskCount = (0, exports.getNormalizedTaskCount)(row.taskCount);
    const isValidTaskCount = (0, exports.isPositiveInteger)(normalizedTaskCount);
    return {
        mutationPatch: { taskCount: normalizedTaskCount },
        optimisticRow: Object.assign(Object.assign({}, row), { taskCount: normalizedTaskCount }),
        shouldShowTaskCountError: !isValidTaskCount,
    };
};
exports.computeChangeResult = computeChangeResult;
const updateEditableFieldsInCache = (cache, queryVariables, row) => {
    var _a, _b, _c;
    let existing = null;
    try {
        existing = cache.readQuery({
            query: get_hlqa_tasks_query_1.GET_HLQA_TASKS,
            variables: queryVariables,
        });
    }
    catch (_d) {
        existing = null;
    }
    if (!((_c = (_b = (_a = existing === null || existing === void 0 ? void 0 : existing.catalog) === null || _a === void 0 ? void 0 : _a.priorityTasks) === null || _b === void 0 ? void 0 : _b.edges) === null || _c === void 0 ? void 0 : _c.length)) {
        return;
    }
    cache.writeQuery({
        query: get_hlqa_tasks_query_1.GET_HLQA_TASKS,
        variables: queryVariables,
        data: Object.assign(Object.assign({}, existing), { catalog: Object.assign(Object.assign({}, existing.catalog), { priorityTasks: Object.assign(Object.assign({}, existing.catalog.priorityTasks), { edges: existing.catalog.priorityTasks.edges.map((edge) => {
                        var _a, _b, _c, _d;
                        const isTargetRow = edge.node.task === row.task
                            && edge.node.productTreeNodeId === row.productTreeNodeId
                            && edge.node.productLabelValidationId === row.productLabelValidationId;
                        if (!isTargetRow) {
                            return edge;
                        }
                        return Object.assign(Object.assign({}, edge), { node: Object.assign(Object.assign({}, edge.node), { priority: (_a = row.priority) !== null && _a !== void 0 ? _a : null, taskCount: (_b = row.taskCount) !== null && _b !== void 0 ? _b : null, assignedTo: (_c = row.assignedTo) !== null && _c !== void 0 ? _c : null, status: (_d = row.status) !== null && _d !== void 0 ? _d : null }) });
                    }) }) }) }),
    });
};
exports.updateEditableFieldsInCache = updateEditableFieldsInCache;
